import template from './routes.html';
import controller from './routes.controller';
import './routes.scss';

let branchManagementRoutesComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default branchManagementRoutesComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/routes.component.js